import React from 'react'
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import OutletsLayerList from '../components/OutletsList';

export const OutletsList = () => {
  return (
<>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Outletslist" /> */}
      <OutletsLayerList/>

      </MasterLayout>
</>  )
}
